import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import SortableList from './SortableList';
import {arrayMoveMutable} from 'array-move';
import getObjectValue from 'libs/getObjectValue';

const style = theme => ({
	root: {

	}
})

function SortableContainer({
	classes,
	formikProps,
	id,
	children,
}) {

	const onSortEnd = ({oldIndex, newIndex}) => {
		const elements = getObjectValue(id, formikProps.values)
		arrayMoveMutable(elements, oldIndex, newIndex)
		formikProps.setFieldValue(id, elements);
	}

	return (
		<SortableList
			formikProps={formikProps}
			id={id}
			onSortEnd={onSortEnd}
			useDragHandle
			children={children}
		/>
	)
}

SortableContainer.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(SortableContainer);